// Translations for all UI text in 2 languages: English and Chinese

const translations = {
  en: {
    // Language dropdown
    interface_language: "Interface Language",
    english: "English",
    chinese: "Chinese",
    
    // Navigation
    home: "Home",
    training_modules: "Training Modules",
    topic_exploration: "Topic Exploration",
    personal_profile: "Personal Profile",
    simulation_training: "Simulation Training",
    mock_exam: "Mock Test",
    knowledge_base: "Knowledge Base",
    
    // Main banner
    hero_title: "IELTS Gamified Learning Tool",
    hero_subtitle_middle: "Shape Your Unique Band 9 Answers",
    hero_subtitle: "Your Stories, Your Insights, Your Scores, Your Success.",
    
    // Wish Pool
    wish_pool: "IELTS Wish Pool",
    your_ideal_score: "Your Ideal Score",
    score_placeholder: "e.g. 7.0",
    luck_boosting: "Luck boosting",
    back: "Back",
    your_score: "Your ideal score: ",
    
    // Training Features Section
    speaking_training: "Speaking Training",
    gamified_mode: "Gamified Response Mode",
    play_and_practice: "Play while practicing",
    immersive_scene: "Immersive Response Scene",
    immersive_scene_desc: "Real immersive response environment",
    multiple_coverage: "Multi-question Coverage",
    multiple_coverage_desc: "One answer applies to multiple scenarios",
    precise_assessment: "Precise Assessment",
    precise_assessment_desc: "Precise evaluation and targeted optimization",
    start_simulation: "Start Mock Test",
    
    // Topic Detail Page parts
    part2_title_detail: "Part 2",
    part3_title_detail: "Part 3",
    
    // Form fields
    fill_info: "Please fill in the information",
    enter_username: "Please enter username",
    exam_deadline: "IELTS exam deadline (days)",
    confirm: "Confirm",
    
    // Floating bottle topics section
    topic_library: "Floating Bottle Topic Library",
    precise_prediction: "Precise Exam Prediction",
    prediction_desc: "Precisely predict exam topics based on IELTS sources",
    share_inspiration: "Share Answer Inspiration",
    share_desc: "Reference topic drifts to share answer inspiration",
    global_thinking: "Global Thinking Collision",
    global_desc: "Focus on global vision and collide thoughts together",
    participate_topic: "Participate in Topic Drift",
    
    // Topic Detail Page
    topic_not_found: "Topic not found",
    back_topic: "Back",
    statistics_note: "According to statistics, IELTS Part 1 has a high proportion of previous questions (about 70%). Part 2 is split evenly with 50% classic questions and 50% adapted/new questions. Part 3 has the highest proportion of new questions (about 40% related to social phenomena). Therefore, in this prediction module, only Part 2 and Part 3 are displayed.",
    input_answer: "Input Answer",
    recording: "Recording...",
    package_answer: "Package answer & set adrift",
    sharing: "Sharing...",
    retrieve_bottle: "Retrieve a drift bottle",
    bottle_retrieved: "Bottle retrieved",
    recording_prompt: "Recording, please start answering...",
    listening: "Listening to your answer...",
    recording_instruction1: "1. Please speak clearly into the microphone",
    recording_instruction2: "2. Voice will be captured in real-time until you click \"Finish\"",
    recording_instruction3: "3. You can answer in English or Chinese, the system recognizes both",
    recording_instruction4: "4. Suggested answer time is 1-2 minutes, not exceeding 3 minutes",
    finish: "Finish",
    your_answer: "Your Answer",
    top_rated_answers: "Top-rated Answers",
    reference_note: "Top-rated answers are for reference only, memorization is not encouraged! Everyone can produce high-scoring answers based on their unique experiences!",
    found_bottle: "Great! You've found a drift bottle!",
    no_bottles: "No relevant drift bottles found at the moment. Please try again later!",
    browser_not_supported: "Sorry, your browser does not support speech recognition. Please try using Chrome browser.",
    answer_shared: "Your answer has been packaged into a drift bottle and set to sail!",
    no_speech_detected: "No speech detected. Please try again.",
    
    // Modal
    mock_exam: "Mock Test",
    optimizing: "Feature being optimized",
    optimization_message: "We are optimizing the mock exam feature to provide a more targeted practice experience for each test-taker. This feature will be launched soon, stay tuned!",
    return_home: "Return to Home",
    
    // Part 2 Training Module
    part2_preparation_note: "<strong>Part 2 preparation time is <strong>1</strong> minute, and the speaking time is typically <strong>1.5</strong> to <strong>2</strong> minutes. <strong>The current time is set to the standard exam default. You can adjust it manually according to your needs.</strong>",
    part2_title: "Part 2 Long Turn Training",
    part2_description: "Part 2 requires the candidate to give a 1-2 minute long talk. Candidates will receive a task card and have 1 minute preparation time",
    topic_card: "Topic Card",
    get_new_topic: "Get New Topic",
    preparation_phase: "Preparation Phase",
    speaking_phase: "Speaking Phase",
    seconds: "seconds",
    prepare_topic_tip: "Please prepare how to answer this topic",
    start_answering_tip: "Please start your answer",
    recording_status: "Recording in progress",
    preparation_time: "Preparation Time",
    speaking_time: "Speaking Time",
    start_practice: "Start Practice",
    practicing: "Practicing...",
    practice_conversation: "Practice Conversation",
    assistant: "Assistant",
    user: "User",
    view_text: "View Text",
    discuss_topic: "Let's discuss this topic: ",
    voice_message: "🔊 Voice message",
    no_speech_content: "(No speech content detected)",
    
    // Part 3 Training Module
    part3_preparation_note: "<strong>According to Part 3 rules, this section defaults to one initial question and three follow-up questions, with one minute for each. You can manually adjust the time to your preference.</strong>",
    part3_title: "Part 3 In-depth Discussion Training",
    part3_description: "Part 3 requires candidates to analyze and discuss in-depth questions from the examiner, usually expanding on the Part 2 topic, requiring more complex viewpoints",
    part3_start_training: "Now starting Part 3 in-depth discussion training. Please answer the following question:",
    welcome_to_part3: "Welcome to IELTS Part 3 in-depth discussion training. Click the \"Start Practice\" button to begin.",
    no_speech_detected_part3: "(No speech detected)",
    examiner_thinking: "The examiner is thinking of the next question...",
    speech_recognition_error: "Speech recognition error",
    speech_recognition_error_alert: "Speech recognition failed, please check microphone permissions or refresh the page to try again",
    question_answer_chat: "Examiner Questions & Practice Conversation",
    change_topic: "Change Topic",
    question1_answer_time: "Question 1 Answer Time",
    question2_answer_time: "Question 2 Answer Time",
    question3_answer_time: "Question 3 Answer Time",
    question4_answer_time: "Question 4 Answer Time",
    question_listening_phase: "Question {number} Listening Phase",
    question_answering_phase: "Question {number} Answering Phase",
    listening_tip_first: "Please listen to the question (if needed), you can click \"Change Topic\" to switch questions.",
    listening_tip_followup: "Please listen carefully to the follow-up question, you can click \"Listen again\" to hear it again.",
    examiner: "Examiner",
    candidate: "Candidate",
    listen_again: "Listen again",
    
    // TrainingContainer Common
    welcome_to_training: "Welcome to IELTS Speaking Test",
    start_mock_exam: "Start Mock Test",
    return_to_home: "Return to Home",
    part1_training: "Part 1 Training",
    part2_training: "Part 2 Training",
    part3_training: "Part 3 Training",
    days: "days",
    exam_date: "Exam Date:",
    
    // Conversation detail
    conversation_detail: "Conversation Detail",
    practice: "Practice",
    hidden_text: "hidden text",
    
    // Post-training completion modal
    exercise_completed: "Exercise Completed!",
    continue_or_end: "Do you want to continue practicing or end the training?",
    continue_practice: "Continue Practice",
    repeat_topic: "Repeat This Topic",
    end_training: "End Training",
    
    // Training end options
    training_end_options: "Training End Options",
    view_history_or_report: "You can view conversation history",
    view_conversation_history: "View Conversation History",
    view_improvement_report: "View Improvement Report",
    
    // Conversation history
    conversation_history: "Conversation History",
    history_save_notice: "Note: All conversation records will only be saved for 3 days, please export them in time.",
    export_records: "Export Records",
    round: "Round",
    messages: "messages",
    close: "Close",
    
    // Improvement report
    ielts_improvement_report: "IELTS Speaking Improvement Report",
    feature_optimizing: "Feature being optimized",
    report_optimization_message: "We are optimizing the improvement report feature to provide more targeted assessment for each training module. This feature will be launched soon, stay tuned!",
    
    // Score Report
    answer_records: "Answer Records",
    score_analysis: "Score Analysis",
    suggestions: "Answer Optimization",
    answer_optimization: "Answer Optimization",
    optimized_answers: "Optimized Answers",
    your_answer: "Your Answer",
    improved_version: "Improved Version",
    key_improvements: "Key Improvements",
    practice_tips: "Practice Tips",
    overall_feedback: "Overall Feedback",
    no_answer_records: "No answer records available",
    score: "Score",
    overall_score: "Overall Score",
    score_details: "Score Details",
    fluency_coherence: "Fluency and Coherence",
    lexical_resource: "Lexical Resource",
    grammatical_range: "Grammatical Range and Accuracy",
    analysis: "Analysis",
    practice_recommendation: "Practice Recommendation",
    expandable_topics: "Expandable Topics",
    answer_pattern_apply: "Your answer pattern can be applied to these similar topics:",
    practice_this_topic: "Practice this topic",
    report_generating: "Generating analysis report",
    please_wait: "Please wait a moment...",
    
    // Footer
    improve_english: "Improve Your English Speaking Ability",
    quick_links: "Quick Links",
    contact_us: "Contact Us",
    follow_us: "Follow Us",
    wechat: "WeChat",
    weibo: "Weibo",
    bilibili: "Bilibili",
    copyright: "© 2023 Talktastic. All rights reserved.",
    
    // Common UI elements for Part 1
    current_phase: "Current Phase:",
    waiting_to_start: "waiting to start",
    countdown: "Countdown:",
    reset_game: "Play Another Round",
    answer_phase: "answering phase",
    preparation_phase_part1: "preparation phase",
    please_listen: "please listen",
    recording_voice: "Recording voice",
    finish_congratulation: "Congratulations! You've reached the finish line!",
    part1_question_count: "IELTS Part 1 typically has 8-12 questions. You can use the number of topics you've drawn this round to decide whether to play another round.",
    records_save_notice: "⚠️ Note: System records are only saved for three days. Please remember to download them in time!",
    export_conversation: "Export Conversation Records",
    view_score_report: "View Score Report",
    update_vocabulary: "Update Vocabulary",
    listen_and_prepare: "(please listen and prepare)",
    rollDice: "Roll Dice",
    
    // Personal Profile Page
    ielts_task_introduction: "IELTS Task Introduction",
    immersive_task_intro: "The essential purpose of IELTS assessment is to see a person who can communicate daily and exchange views in English worldwide. From self-introduction in Part 1 to view exchange in Part 3, it's about seeing a complete character portrait including personality, preferences, experiences, and viewpoints.",
    magic_code: "So our magic code to lower the difficulty of the exam is: Show a consistent, vivid character.",
    personality_action: "Personality determines action. Creating a consistent character can start with personality, then behaviors and hobbies, daily life, frequently spreading similar vocabulary and expressions to different scenarios, ensuring our on-the-spot response and fluency.",
    gamified_profile: "Based on this underlying logic, we've created a gamified personal profile and tasks. The contents of the profile are very important. Once completed, you'll find that many test scenarios can be retrieved from your profile.",
    click_confirm: "Click \"Confirm\" to start your immersive IELTS task!",
    immersive_game_welcome: "Welcome to IELTS Immersive Game",
    pickle_planet_intro: "Welcome to the IELTS immersive game! You have come to the Pickle Planet for special reasons. On this planet, the leader changes every day, and various flavored pickles are the source of all life. You need to complete planet registration, blind dating, and leader election tasks to gain recognition from planet residents who will allocate pickles to you. Otherwise, you won't be able to survive. Now, let's start by completing your profile!",
  },
  
  zh: {
    // 语言下拉菜单
    interface_language: "界面语言",
    english: "英文",
    chinese: "中文",
    
    // 导航
    home: "首页",
    training_modules: "训练模块",
    topic_exploration: "话题探索",
    personal_profile: "个人档案",
    simulation_training: "模拟训练",
    mock_exam: "模拟测试",
    knowledge_base: "知识库",
    
    // 主横幅 - 即使在中文界面下也保持英文
    hero_title: "IELTS Gamified Learning Tool",
    hero_subtitle_middle: "Shape Your Unique Band 9 Answers",
    hero_subtitle: "Your Stories, Your Insights, Your Scores, Your Success.",
    
    // 许愿池
    wish_pool: "雅思许愿池",
    your_ideal_score: "您的理想分数",
    score_placeholder: "例如: 7.0",
    luck_boosting: "好运加持中",
    back: "返回",
    your_score: "您的理想分数: ",
    
    // 训练特色部分
    speaking_training: "口语训练专项训练",
    gamified_mode: "游戏化答题模式",
    play_and_practice: "边玩边练",
    immersive_scene: "真实沉浸式场景",
    immersive_scene_desc: "真实沉浸式答题场景",
    multiple_coverage: "一答多题覆盖",
    multiple_coverage_desc: "一个回答适用于多种场景",
    precise_assessment: "精准评估",
    precise_assessment_desc: "精准评测，针对性优化",
    start_simulation: "开始模拟测试",
    
    // 话题详情页部分
    part2_title_detail: "Part 2部分",
    part3_title_detail: "Part 3部分",
    
    // 表单字段
    fill_info: "请填写信息",
    enter_username: "请输入用户名",
    exam_deadline: "雅思考试截止时间（天）",
    confirm: "确定",
    
    // 漂流瓶话题部分
    topic_library: "漂流瓶话题库",
    precise_prediction: "精准预测考题",
    prediction_desc: "根据雅思题源精准预测考题",
    share_inspiration: "共享答题灵感",
    share_desc: "参考话题漂流共享答题灵感",
    global_thinking: "全球思维碰撞",
    global_desc: "聚焦全球视野一起思维碰撞",
    participate_topic: "参与话题漂流",
    
    // 话题详情页
    topic_not_found: "话题不存在",
    back_topic: "返回",
    statistics_note: "据统计，雅思part1的旧题比例较高，约70%。part2新旧各半，50%经典题+50%改编/新题。part3新题比例最高，约40%涉及社会现象。所以在预测考题这个模块，只显示part2和part3。",
    input_answer: "输入回答",
    recording: "正在录音...",
    package_answer: "打包回答，随漂流瓶远航",
    sharing: "分享中...",
    retrieve_bottle: "捞一捞漂流瓶",
    bottle_retrieved: "已捞到漂流瓶",
    recording_prompt: "正在录音，请开始回答...",
    listening: "(正在聆听您的回答...)",
    recording_instruction1: "1. 请对着话筒清晰地表达您的想法",
    recording_instruction2: "2. 语音将被实时捕捉，直到您点击\"完成\"按钮",
    recording_instruction3: "3. 您可以用英语或中文回答，系统都能识别",
    recording_instruction4: "4. 建议回答时间在1-2分钟，不要超过3分钟",
    finish: "完成",
    your_answer: "您的回答",
    top_rated_answers: "高赞回答",
    reference_note: "高赞回答仅供参考，不鼓励背诵！！每个人都能根据自己的独特经历产出高分回答！",
    found_bottle: "太棒啦，捞到一个漂流瓶!",
    no_bottles: "暂时没有找到相关的漂流瓶，请稍后再试！",
    browser_not_supported: "抱歉，您的浏览器不支持语音识别功能。请尝试使用Chrome浏览器。",
    answer_shared: "您的回答已打包成漂流瓶，随海漂流！",
    no_speech_detected: "没有检测到语音输入，请重试。",
    
    // 模态框
    mock_exam: "模拟测试",
    optimizing: "功能正在优化中",
    optimization_message: "我们正在对模拟考试功能进行个性化优化，为每个考生提供更有针对性的练习体验。此功能将尽快上线，敬请期待！",
    return_home: "返回首页",
    
    // Part 2 训练模块
    part2_preparation_note: "part2的准备时间为<strong>1</strong>分钟，回答时间通常为<strong>1.5</strong>到<strong>2</strong>分钟。<strong>现在的时间是考试标准的默认值。可根据自己情况手动调整。</strong>",
    part2_title: "Part 2 长篇演讲训练",
    part2_description: "Part 2要求考生进行1-2分钟的长篇演讲，考生会收到一张任务卡，有1分钟准备时间",
    topic_card: "话题卡",
    get_new_topic: "抽取新话题",
    preparation_phase: "准备阶段",
    speaking_phase: "回答阶段",
    seconds: "秒",
    prepare_topic_tip: "请准备如何回答这个话题",
    start_answering_tip: "请开始您的回答",
    recording_status: "回答录音中",
    preparation_time: "准备时间",
    speaking_time: "回答时间",
    start_practice: "开始练习",
    practicing: "练习中...",
    practice_conversation: "练习对话",
    assistant: "助手",
    user: "用户",
    view_text: "查看原文",
    discuss_topic: "让我们来讨论这个话题：",
    voice_message: "🔊 语音消息",
    no_speech_content: "(未检测到语音内容)",
    
    // Part 3 训练模块
    part3_preparation_note: "<strong>根据part3的规则，此处默认设置一个初始问题和三个临时追问问题，每个问题1分钟。练习者也可手动调整自己满意的时间。</strong>",
    part3_title: "Part 3 深入讨论训练",
    part3_description: "Part 3要求考生就考官提出的深入问题进行分析和讨论，通常围绕Part 2话题展开，需要表达更复杂的观点",
    part3_start_training: "现在开始Part 3深入讨论训练。请回答以下问题：",
    welcome_to_part3: "欢迎来到IELTS Part 3深入讨论训练。点击\"开始练习\"按钮开始训练。",
    no_speech_detected_part3: "(未检测到语音内容)",
    examiner_thinking: "考官正在思考下一个问题...",
    speech_recognition_error: "语音识别错误",
    speech_recognition_error_alert: "启动语音识别失败，请检查麦克风权限或刷新页面重试",
    question_answer_chat: "考官问题与练习对话",
    change_topic: "切换题目",
    question1_answer_time: "问题1回答时间",
    question2_answer_time: "问题2回答时间",
    question3_answer_time: "问题3回答时间",
    question4_answer_time: "问题4回答时间",
    question_listening_phase: "第{number}题听题阶段",
    question_answering_phase: "第{number}题回答阶段",
    listening_tip_first: "请在听题时间内重新听题（如果需要），可以点击\"切换题目\"更换题目。",
    listening_tip_followup: "请在听题时间内仔细听追问问题，可以点击\"重听\"再次听题。",
    examiner: "考官",
    candidate: "考生",
    listen_again: "重听",
    
    // TrainingContainer通用
    welcome_to_training: "欢迎参加雅思口语测试",
    start_mock_exam: "开始模拟测试",
    return_to_home: "返回首页",
    part1_training: "Part 1 训练",
    part2_training: "Part 2 训练",
    part3_training: "Part 3 训练",
    days: "天",
    exam_date: "考试日期:",
    
    // 个人档案页面
    ielts_task_introduction: "雅思任务介绍",
    immersive_task_intro: "雅思的考核的本质目的是要看到一个能够在英语在世界日常交流、观点交换的人。而从part1的自我介绍到part3的观点交流其实就是要看到一个从性格、喜好、经历、观点都完整的人物画像。",
    magic_code: "所以我们要降低考试难度的神奇密码是：展示一个\"一以贯之\"的鲜活的人。",
    personality_action: "性格决定行动。打造一个\"一以贯之\"的人设可以由性格开始，到行为爱好、衣食住行，高频地把一批类似的词汇和表达扩散到不同的场景，从而确保我们的临场反应和流利度。",
    gamified_profile: "基于这个底层逻辑，我们创建了游戏化的个人档案和任务。档案的内容非常重要，完善好了你会发现很多考试场景都能从档案里调取。",
    click_confirm: "点击\"确定\"开始你的雅思沉浸式任务吧！",
    immersive_game_welcome: "欢迎来到雅思沉浸式游戏",
    pickle_planet_intro: "欢迎来到雅思沉浸式游戏，你因为特殊原因来到了酸黄瓜星球。这个星球一天换一个球长，各种口味的酸黄瓜是所有养活生命的来源。你需要在这个星球上完成星球入驻、相亲、竞选球长的任务，才能成功得星球住户的认可给你分配换黄瓜，不否则你将无法存活。现在开始先完成你的档案吧！！",
    
    // 对话详情
    conversation_detail: "对话详情",
    practice: "练习",
    hidden_text: "隐藏文本",
    
    // 训练完成后弹窗
    exercise_completed: "本题练习完成！",
    continue_or_end: "您想继续练习还是结束训练？",
    continue_practice: "继续练习",
    repeat_topic: "重复本题",
    end_training: "结束训练",
    
    // 训练结束选项
    training_end_options: "训练结束选项",
    view_history_or_report: "您可以查看历史对话",
    view_conversation_history: "查看对话历史",
    view_improvement_report: "查看提分报告",
    
    // 对话历史
    conversation_history: "对话历史记录",
    history_save_notice: "注意：所有对话记录只会保存3天，请及时导出保存。",
    export_records: "导出记录",
    round: "轮次",
    messages: "条消息",
    close: "关闭",
    
    // 提分报告
    ielts_improvement_report: "IELTS口语提分报告",
    feature_optimizing: "功能正在优化中",
    report_optimization_message: "我们正在对提分报告功能进行个性化优化，为每个训练模块提供更有针对性的评估。此功能将尽快上线，敬请期待！",
    
    // Score Report
    answer_records: "回答记录",
    score_analysis: "分数分析",
    suggestions: "答案优化",
    answer_optimization: "答案优化",
    optimized_answers: "优化答案",
    your_answer: "您的回答",
    improved_version: "改进版本",
    key_improvements: "主要改进",
    practice_tips: "练习技巧",
    overall_feedback: "整体反馈",
    no_answer_records: "没有可用的回答记录",
    score: "分数",
    overall_score: "总分",
    score_details: "分数详情",
    fluency_coherence: "流利度和连贯性",
    lexical_resource: "词汇资源",
    grammatical_range: "语法范围和准确性",
    analysis: "分析",
    practice_recommendation: "练习建议",
    expandable_topics: "可扩展话题",
    answer_pattern_apply: "您的回答模式可以应用于这些相似话题：",
    practice_this_topic: "练习该话题",
    report_generating: "正在生成分析报告",
    please_wait: "请稍候...",
    
    // 页脚
    improve_english: "提升您的英语口语能力",
    quick_links: "快速链接",
    contact_us: "联系我们",
    follow_us: "关注我们",
    wechat: "微信",
    weibo: "微博",
    bilibili: "B站",
    copyright: "© 2023 Talktastic. 保留所有权利。",
    
    // Part 1 界面通用元素
    current_phase: "当前阶段：",
    waiting_to_start: "等待开始",
    countdown: "倒计时：",
    reset_game: "再来一轮",
    answer_phase: "回答阶段",
    preparation_phase_part1: "准备阶段",
    please_listen: "请听题",
    recording_voice: "正在录制语音",
    finish_congratulation: "恭喜！你已到达终点！",
    part1_question_count: "雅思part1环节大概有8到12个问题，可以参考本轮你抽到的话题数决定是否再来一轮",
    records_save_notice: "⚠️ 提示：系统记录只保存三天，请记得及时下载保存！",
    export_conversation: "导出对话记录",
    view_score_report: "查看提分报告",
    update_vocabulary: "更新词汇",
    listen_and_prepare: "(请听题并准备)",
    rollDice: "摇步数",
  }
};

export default translations; 